import { createSlice } from '@reduxjs/toolkit';
import { Slices } from 'ducks/slices';

const initialState = {
  follow_scroll: false,
};

const scrollSlice = createSlice({
  name: Slices.SCROLL,
  initialState,
  reducers: {
    setScroll: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setScroll } = scrollSlice.actions;

export default scrollSlice.reducer;
